/**
 * @param fn {*}
 * @return {Boolean}
 */
export const isFunction = (fn) => typeof fn === 'function';

/**
 * An object is plain if it's created by either
 * {}, new Object() or Object.create(null).
 *
 * @param val {*}
 * @return {Boolean}
 */
export const isPlainObject = (val) => {
  if (!val || Object.prototype.toString.call(val) !== '[object Object]') {
    return false;
  }

  const prototype = Object.getPrototypeOf(val);

  return !prototype || prototype === Object.getPrototypeOf({});
};

/**
 * Checks if `value` is likely a prototype object.
 *
 * @param {*} value The value to check.
 * @return {Boolean} Returns `true` if `value` is a prototype, else `false`.
 */
export const isPrototype = (value) => {
  const Ctor = value && value.constructor;
  const proto = (isFunction(Ctor) && Ctor.prototype) || Object.prototype;

  return value === proto;
};

/**
 * Checks if value is empty.
 *
 * Objects are considered empty if they have no own enumerable string keyed properties.
 * Array-like values such as arguments objects, arrays, strings or custom collections
 * are considered empty if they have a length of 0.
 *
 * @param val {*}
 * @return {Boolean}
 */
export const isEmpty = (val) => {
  if (!val || isFunction(val)) {
    return true;
  }

  if (typeof val.length === 'number') {
    return !val.length;
  }

  if (isPrototype(val) || isPlainObject(val) || typeof val === 'object') {
    return !Object.keys(val).length;
  }

  return true;
};
